import { useTheme } from "@/components/theme-provider";
import { useEffect, useState } from "react";

// Hook to detect dark mode preference
export function useDarkMode() {
    const { theme } = useTheme();
    const [isDark, setIsDark] = useState(false);
  
    useEffect(() => {
      const checkDarkMode = () => {
        const root = document.documentElement;
        setIsDark(root.classList.contains('dark'));
      };
  
      // Check initial state
      checkDarkMode();
  
      // Watch for class changes on the document element
      const observer = new MutationObserver(checkDarkMode);
      observer.observe(document.documentElement, {
        attributes: true,
        attributeFilter: ['class'],
      });
  
      return () => observer.disconnect();
    }, [theme]);
  
    return isDark;
  }